import { useRouter } from 'next/router';
import { FC, useContext } from 'react';

import { SearchContext } from 'state/search';
import { useTranslation } from 'utils/i18n';
import VenueCard from '../venueCard';

interface Venue {
  id: number;
  name: string;
  location: string;
  distance: number;
  image: string;
}

interface Props {
  location: string;
  venues: Venue[];
  radius?: number;
  minVenues?: number;
}

const NearbyVenues = ({
  venues = [],
  location,
  radius = 50,
  minVenues = 3,
}: Props) => {
  const { t } = useTranslation('common');
  const { actions } = useContext(SearchContext);
  const router = useRouter();

  const handleClick = () => {
    actions.updateLocation(location);
    actions.updateDistance(radius);

    router.push('/find-rooms');
  };

  if (venues.length === 0) {
    return null;
  }

  return (
    <section className="nearby-venues">
      <div className="nearby-venues__header">
        <h3>{t('nearby_venues.title')}</h3>

        {venues.length > minVenues && (
          <button
            type="button"
            className="button button--text"
            onClick={handleClick}
          >
            {t('nearby_venues.view_more')}
          </button>
        )}
      </div>

      <ul className="nearby-venues__venues">
        {venues.map(venue => (
          <VenueCard
            key={venue.name}
            name={venue.name}
            location={venue.location}
            distance={venue.distance}
            image={venue.image}
            url={`${t('navigation.venues.url')}/${venue.id}`}
            component={'li' as unknown as FC}
          />
        ))}
      </ul>
    </section>
  );
};

export default NearbyVenues;
